import { useState } from 'react';

export const useSearchTerm = (): [string, F<string, void>] => {
  const [searchTerm, setSearchTerm] = useState('');

  const handleSetSearchTerm = (newValue: string) => {
    setSearchTerm(newValue.toLowerCase().trimStart());
  };

  return [searchTerm, handleSetSearchTerm];
};
